import {initComponents, openWithParams, getUrl} from "./main_ptx";
import {initForm, initMultiselect} from "./main_modal";
import {submitCurrent} from "./main_form";
import {message} from "./main";

/**
 * add new tab to bootstrap tabs in specified ctx
 * @alias Ptx.fn.addTab
 * @param tabId
 * @param tabName
 * @param ctx
 */
export function addTab(tabId, tabName, ctx) {
	addRemoteTab(tabId,{tabName:tabName, url:false}, ctx);
}

/**
 * add new tab to bootstrap tabs in specified ctx
 * @alias Ptx.fn.addRemoteTab
 * @param tabId
 * @param params config object, must contain tabName, url, optionally cssClass to be added
 * @param ctx
 */
export function addRemoteTab(tabId, params, ctx) {
	const { tabName, url: urlPath, cssClass: css } = params;
	let remote = '';

	if (urlPath) {
		remote = `data-href="${urlPath}" class="ptx-ajax-tab ${css || ''}"`;
	} else {
		remote = css ? `class="${css}"` : '';
	}

	// create the tabd
	$(`<li class="" role="presentation"><a href="#${tabId}" data-bs-toggle="tab" aria-controls="${tabId}" role="tab" ${remote}>${tabName}</a></li>`).appendTo('.nav-tabs', ctx);
	// create the tab content
	$(`<div class="tab-pane" role="tabpanel" id="${tabId}"></div>`).appendTo('.tab-content', ctx);
	if (urlPath) {
		initRemoteTabLoad(`a[href="#${tabId}"]`, ctx);
	}
}

/**
 * remove tab by its id from given ctx
 * @alias Ptx.fn.removeTab
 * @param tabId
 * @param ctx
 * @param showIndex tab if showFirst is > -1, otherwise caller must show some tab by himself
 */
export function removeTab(tabId, ctx, showIndex) {
	//var tabId = $(this).parents('li').children('a').attr('href');
    if (Ptx.modal.ctx.tab && Ptx.modal.ctx.tab.onunload) {
        Ptx.modal.ctx.tab.onunload();
    }
    var tab = $('a[href="#'+tabId+'"]', ctx);
    tab.parents('li').remove('li');
    $('div#'+tabId, ctx).remove();
    if (showIndex > -1) {
    	$('.nav-tabs a:eq('+showIndex+')', ctx).tab('show');
    }
    delete Ptx.modal.ctx.tab;
    Ptx.modal.ctx.tab = {};
}

/**
 * show tab with given tabId (a href="#id"), without hash you must enter
 * @alias Ptx.fn.showTab
 * @param tabId
 * @param ctx
 */
export function showTab(tabId, ctx) {
	var tab = $('a[href="#' + tabId + '"]', ctx);
	tab.trigger('click');
	tab.closest('li').trigger('click');
}

/**
 * setup tab to be loaded remotely
 * @alias Ptx.fn.initRemoteTabLoad
 * @param sel - tab selector
 * @param ctx - ctx
 */
export function initRemoteTabLoad(sel, ctx) {
	$(sel, ctx).on('click', function(e) {
		e.preventDefault();
		var link = $(this);
		var tgt = $('#'+link.attr('aria-controls'));
		var urlPath =  getUrl(link.data('href'));
		Ptx.modal.ctx.tab = {};
		openWithParams(urlPath,"GET", {sm_dec:'none', showInTab:true}, function(data, srv) {
			tgt.html(data);
			initTab(tgt);
		});
	});
}

/**
 * init components in one tab
 * @alias Ptx.fn.initTab
 * @param ctx
 */
export function initTab(ctx) {
	initForm(ctx);
	initComponents(ctx);
	initMultiselect(ctx);

	const ul = $('.nav-tabs', ctx);
	const liElements = ul.children('li').toArray();
	const tabContent = $(ul).next('.tab-content').find('.tab-pane').length
			? $(ul).next('.tab-content').find('.tab-pane') : $(ul).next('form').find('.tab-content').find('.tab-pane');


// When clicking a panel, this code checks which one you clicked and stores the last clicked tab ID to memory as lastTab.
	liElements.forEach((li) => {
		li.addEventListener('click', (event) => {
			const clickedLi = $(li);
			const clickedLink = clickedLi.find('a');
			const clickedLinkName = clickedLink.attr('aria-controls');

			if (event.target.tagName.toLowerCase() !== 'a') { // without this if, it would trigger both our click and <a> click
				clickedLink.trigger('click');
			}

			if(Ptx.modal.ctx) {
				Ptx.modal.ctx.lastTab = liElements.indexOf(clickedLi[0]);
				Ptx.modal.ctx.url = Ptx.modal.ctx.url.replace(/(tab=)\d+/, "$1" + Ptx.modal.ctx.lastTab);
			}

			ul.find('li').removeClass('active');
			tabContent.removeClass('active');
			$('#' + clickedLinkName, ctx).addClass('active');
			clickedLi.addClass('active');
		});
	});


	//* M - close current tab without confirm
	$('.ptx-close-current-tab', ctx).on('click', function(e) {
		e.preventDefault();
		var tabId = currentTabId($(this));
		var tabCount = parseInt($(".nav-tabs li", ctx).length); // This gets the amount of tabs

		// Checks if the tab count is higher than the amount of tabs. The reason for -2 is that tab IDs start from 0 and 1 - on top of that, we are closing
		// a tab. If that happens, the previous tab becomes the first one.
		if(Ptx.modal.ctx.lastTab > (tabCount - 2) || Ptx.modal.ctx.lastTab < 0) {
			Ptx.modal.ctx.lastTab = 0;
		}
		removeTab(tabId, Ptx.modal.ctx.window, Ptx.modal.ctx.lastTab);
	});
	
	$('.ptx-pagination-call', ctx).on('click', function(e){
		e.preventDefault();
		var pageNumber = $(this).data('page-number');
		$('.ptx-tab-pagination-form', ctx).each(function() {
			var form = $(this);
				tabSubmitForm(ctx, form, pageNumber);
			});
	});
	
	$('.ptx-tab-submit-form', ctx).on('click', function(e){
		e.preventDefault();
		var form = $(this).closest('form');
		var tgt = form.data('target-selector') || ''; 
		//TODO better submitting
		var pageNumber = $('input[name="pageNumber"]', form).data('page-number');
		submitCurrent(form, tgt, function(data,srv) {
			if (srv.isJson) {
				var tabId = currentTabId($(this));
				removeTab(tabId, Ptx.modal.ctx.window, Ptx.modal.ctx.lastTab);
			} else {
				initTab(ctx);
			}
			
		});
	});
	
	$('.ptx-tab-auto-submit', ctx).on('change', function(e) {
		e.preventDefault();
		var form = $(this).closest('form');
		$('.ptx-tab-submit-form', form).trigger('click');
	});

	if(Ptx.modal.ctx) {
		if (Ptx.modal.ctx?.tab.onload) {
			Ptx.modal.ctx.tab.onload(ctx);
		}

		Ptx.modal.ctx.tab.refreshAfterAction = function(data, svr) {
			if (data.submitFinal) {
				message(data.finalMsg);
				var tabId = currentTabId(ctx);
				ctx = Ptx.modal.ctx.window ? Ptx.modal.ctx.window : document;
				var link = $('a[href="#' + tabId + '"]', ctx);
				var tgt = $('#'+link.attr('aria-controls'));
				var urlPath = link.attr("data-href");
				Ptx.modal.ctx.tab = {};
				openWithParams(urlPath,"GET", {sm_dec:'none', showInTab:true}, function(data, srv) {
					tgt.html(data);
					initTab(tgt);
				});
			}
		};
	}
}

/**
 * submit modal tab form, supports pagination
 * @alias Ptx.fn.tabSubmitForm
 * @param ctx
 * @param form
 * @param pageNumber
 */
export function tabSubmitForm(ctx, form, pageNumber) {
	$('input[name="pageNumber"]', form).val(pageNumber);
	var hidden = $('<input type="hidden" name="sm_dec" value="none" />');
	form.append(hidden);
	submitCurrent(form, '', function(data,srv) {
		if (srv.isJson) {
			var tabId = currentTabId($(this));
			removeTab(tabId, Ptx.modal.ctx.window, 0);
		} else {
			initTab(ctx);
		}
	},{useDefaultSerialization:true});

}

/**
 * find current tab id ele is in
 * @alias Ptx.fn.currentTabId
 * @param ele
 * @return tabId
 */
export function currentTabId(ele) {
	return ele.closest('div.tab-pane.active').attr('id');
}
